<div class="full-width-dropdown">
    <mat-form-field class="form-field-no-extra-space select-dealer" appearance="none" *ngIf="subdealers?.length > 1">
        <mat-select #selectDealer id="test" [(ngModel)]="entityModel" (ngModelChange)="selectEntity($event)">
            <mat-option value="" i18n="@@SHARED.LIST.SELECT_DEALER">All Companies</mat-option>
            <ng-container *ngFor="let subdealer of subdealers">
                <mat-option [value]="subdealer">{{ subdealer.name }}</mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>
</div>
